import { GET_INITIAL_TOKENS, GET_INITIAL_TOKENS_FAIL, GET_INITIAL_TOKENS_SUCCESS } from 'redux/Reducers/Template/TemplateReducer';
import Store from 'redux/store';

/* eslint-disable */
const FetchTemplate = async (
    User,
    finallyCallback = () => {},
) => {
    const getTemplate = () => {
        const campaignId = User?.profile['custom:campaign_id'] || process.env.REACT_APP_TENANT_ID;
        const catalogId = User?.profile['custom:catalog_id'] || process.env.REACT_APP_CATALOG_ID

        const urlPath = process.env.REACT_APP_TEMPLATE_DOMAIN || 'https://vertice-ds.s3.amazonaws.com/templates/';
        const fileName = `skin-${campaignId || 1}-${catalogId || 1}.json`;
        return `${urlPath}${fileName}`;
    }
    Store.dispatch({ type: GET_INITIAL_TOKENS })
    fetch(getTemplate())
    .then(response => {
      return response.json();
    })
    .then(data => {
      Store.dispatch({
        type: GET_INITIAL_TOKENS_SUCCESS,
        payload: {
          ...data,
        },
      });
    })
    .catch(error => {
      Store.dispatch({
        type: GET_INITIAL_TOKENS_FAIL,
        error,
      });
    })
    .finally(() => {
      finallyCallback();
    });
  
}

export default FetchTemplate;